
export default function Scheduler() {
  const handleAddToContacts = () => {
    // Create vCard data
    const vCard = `BEGIN:VCARD
VERSION:3.0
FN:Jacob - Mercedes Specialist
TEL;TYPE=CELL:(847) 957-3340
EMAIL:jacob@mercedeswithjacob.com
URL:https://mercedeswithjacob.square.site/
NOTE:Mercedes-Benz Sales Specialist
END:VCARD`;

    // Create blob and download
    const blob = new Blob([vCard], { type: 'text/vcard' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Jacob-Mercedes.vcf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <section id="scheduler" className="py-24 bg-gradient-to-b from-zinc-900 to-black">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Schedule Your <span className="text-amber-400">Appointment</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Book a personalized consultation to discuss your dream Mercedes-Benz. I'll help you find the perfect vehicle and arrange a test drive at your convenience.
          </p>
        </div>

        <div className="bg-zinc-900 rounded-lg shadow-2xl overflow-hidden">
          <div className="aspect-[16/9] w-full">
            <iframe
              src="https://mercedeswithjacob.square.site/"
              className="w-full h-full"
              style={{ minHeight: '600px' }}
              title="Schedule Appointment"
            />
          </div>
        </div>

        <div className="mt-8 flex justify-center">
          <button
            onClick={handleAddToContacts}
            className="px-8 py-3 bg-amber-400 text-black font-semibold rounded-lg hover:bg-amber-500 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-contacts-line text-xl"></i>
            Add to Contacts
          </button>
        </div>
      </div>
    </section>
  );
}
